const DEFAULT_REGIONS = [
    {
        value: 3,
        label: 'Москва',
    },
    {
        value: 444,
        label: 'Санкт-Петербург',
    },
    {
        value: 108,
        label: 'Московская область',
    },
    {
        value: 886,
        label: 'Ленинградская область',
    },
];
const LEFT_COL = DEFAULT_REGIONS.slice(0, 2);
const RIGHT_COL = DEFAULT_REGIONS.slice(2);
export { LEFT_COL, RIGHT_COL };
//# sourceMappingURL=defaults.js.map